<div class="chart">
  <canvas #canvas>{{ chart }}</canvas>
</div>
